import type { ServerClock } from "odyssey-shared";
import type { LightingControl } from "./control.ts";

/**
 * What a `welcome` does to the light layer (PROTOCOL.md 6.100.0): sets the server's time, replacing any sample the page holds so a host whose clock is behind is followed, and puts the sky back to the
 * everyday one. The gateway sends the `sky` frame of an override in force after the welcome, so a page that was disconnected
 * while a GM cleared the override, or while the gateway restarted, is not left under one that has ended.
 *
 * @param control The page's lighting control.
 * @param clock The page's copy of the server's clock.
 * @param serverTime The welcome's server time, or undefined when it carried none.
 * @param monotonic The page's monotonic clock in milliseconds as the welcome arrived.
 */
export function lightingWelcome(control: LightingControl, clock: ServerClock, serverTime: number | undefined, monotonic: number): void {
  lightingCrossingWelcome(control);
  if (serverTime !== undefined) {
    clock.forget();
    clock.note(serverTime, monotonic);
  }
}

/**
 * What a seamless crossing's `welcome` does to the light layer: puts the sky back to the everyday one and leaves the clock
 * alone. The crossing welcome is handled behind the restage, so its send stamp paired with the late handling time would step
 * the page's shared clock by about a second; the clock the page already holds is still true across the seam.
 *
 * @param control The page's lighting control.
 */
export function lightingCrossingWelcome(control: LightingControl): void {
  control.sky = "none";
}
